import React from "react";
import ListExec from "./executive/list";
import ListDesk from "./desk/list";
import { getCookie } from "../../utils";
import CONSTANT from "../../constant";

function DakList(props) {
  const user = getCookie(CONSTANT.cookie.userDetail);
  const { designationCode } = user;
  const {history} = props
  return designationCode === 370 ? (
    <ListDesk history={{...history}} />
  ) : (
    <ListExec history={history} />
  );
}

export default DakList;
